export * from './tab.component';
export * from './tabs.component';
